import { CRM_SYNC_STORE_EVENT_NAMES, type CrmSyncStoreEventName } from './store-events.types';

const CRM_SYNC_STORE_EVENT_NAME_SET = new Set<string>(CRM_SYNC_STORE_EVENT_NAMES);

export function isCrmSyncStoreEventName(name: string): name is CrmSyncStoreEventName {
  return CRM_SYNC_STORE_EVENT_NAME_SET.has(name);
}
